import state from './moduleDocumentState'
import mutations from './moduleDocumentMutations.js'
import actions from './moduleDocumentActions.js'
import getters from './moduleDocumentGetters.js'

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
